<lerb-component
  [mode]="getMode()"
  [language]="getLanguage()"
  [product]="getProduct()"
  [host]="getHost()"
  [initialType]="getInitialType()"
  [isOverlayMode]="getIsOverlayMode()"
></lerb-component>
